import React from 'react';
import styled from 'styled-components';

const Screen8 = ({ language }) => {
  const englishText = `The survey contains a number of statements and questions. Please select the response that best represents your personal opinion. If you are unable to provide an answer, please skip it and go to the next question. There is a section at the end of the survey where you can provide a response in your own words. To preserve your anonymity, please do not identify yourself in the written response question.

IMPORTANT: This survey is unique to you - do not forward this link to anyone else. To re-enter your survey where you were interrupted, you will need the URL that was included in your survey invitation. Please keep your survey invitation until you have submitted your survey.`;

  const frenchText = `Le sondage contient un certain nombre d'énoncés et de questions. Veuillez sélectionner la réponse qui représente le mieux votre opinion personnelle. Si vous n'êtes pas en mesure de fournir une réponse, veuillez passer à la question suivante. Une section est prévue à la fin du sondage pour que vous puissiez fournir une réponse dans vos propres mots. Pour conserver l'anonymat, veillez à ne pas vous identifier dans les réponses écrites fournies pour les questions.

IMPORTANT : Ce sondage est unique à vous - ne transmettez pas ce lien à quelqu'un d'autre. Pour reprendre le sondage à l'endroit où vous vous étiez arrêté, vous aurez besoin du numéro d'identification qui vous a été fourni ou de l'URL qui était associée lors votre invitation au sondage. Veuillez conserver votre numéro d'identification ou votre invitation au sondage jusqu'à ce que vous ayez soumis celui-ci.`;

  // Split text to highlight IMPORTANT section
  const splitEnglishText = englishText.split('IMPORTANT:');
  const splitFrenchText = frenchText.split('IMPORTANT :');

  return (
    <Container>
      <ContentWrapper>
        <TextSection>
          {language === 'FR' ? splitFrenchText[0] : splitEnglishText[0]}
        </TextSection>
        
        <ImportantSection>
          <ImportantHeader>{language === 'FR' ? 'IMPORTANT :' : 'IMPORTANT:'}</ImportantHeader>
          <ImportantText>
            {language === 'FR' ? splitFrenchText[1] : splitEnglishText[1]}
          </ImportantText>
        </ImportantSection>
        
        <ContactSection>
          {language === 'FR' 
            ? <span>Si vous avez des questions, veuillez communiquer avec <EmailLink href="mailto:Yantha.Brody@sbmfc.com">Yantha.Brody@sbmfc.com</EmailLink> ou <EmailLink href="mailto:dean.fulford@stratford.group">dean.fulford@stratford.group</EmailLink></span>
            : <span>If you have any questions, please email <EmailLink href="mailto:Yantha.Brody@cfmws.com">Yantha.Brody@cfmws.com</EmailLink> or <EmailLink href="mailto:dean.fulford@stratford.group">dean.fulford@stratford.group</EmailLink></span>
          }
        </ContactSection>
      </ContentWrapper>
    </Container>
  );
};

export default Screen8;

const Container = styled.div`
  width: 100%;
  padding: 20px;
  background-color: #ffffff;
`;

const ContentWrapper = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

const TextSection = styled.p`
  font-size: 1.1rem;
  line-height: 1.6;
  color: #333;
  margin-bottom: 20px;
  white-space: pre-line;
`;

const ImportantSection = styled.div`
  background-color: #f9f9f9;
  border-left: 4px solid #e0a800;
  padding: 15px;
  margin: 20px 0;
`;

const ImportantHeader = styled.h3`
  color: #d14900;
  margin-top: 0;
  margin-bottom: 10px;
  font-weight: bold;
`;

const ImportantText = styled.p`
  font-size: 1.1rem;
  line-height: 1.6;
  color: #333;
  white-space: pre-line;
`;

const ContactSection = styled.p`
  font-size: 1.1rem;
  line-height: 1.6;
  color: #333;
  margin-top: 20px;
  padding-top: 10px;
  border-top: 1px solid #e0e0e0;
`;

const EmailLink = styled.a`
  color: #0066cc;
  text-decoration: none;
  transition: color 0.2s ease;
  
  &:hover {
    color: #004499;
    text-decoration: underline;
  }
`; 